import { initializeApp } from "firebase/app";

import {
  getFirestore
} from "firebase/firestore";

import {
  getAuth
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyADBEOhdK2kUwUzXhPt4tCnFMWHSPVLChw",
  authDomain: "vita-platform-47551.firebaseapp.com",
  projectId: "vita-platform-47551",
  storageBucket: "vita-platform-47551.firebasestorage.app",
  messagingSenderId: "680638964862",
  appId: "1:680638964862:web:bf9a3199dd1d06e90e242f"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);